var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region StudentDetailDay - Ctor
    ns.StudentDetailDay = function StudentDetailDay(reservations, schedules, dayOfWeek, dayName, studentID, activityID) {
        this.initialize(reservations, schedules, dayOfWeek, dayName, studentID, activityID);
    }
    // #endregion

    // #region StudentDetailDay - Inheritance

    ns.StudentDetailDay.prototype = new ns.ScheduleResourceDetailDayBase();
    ns.StudentDetailDay.prototype.constructor = ns.StudentDetailDay;
    ns.StudentDetailDay.prototype.parent = ns.ScheduleResourceDetailDayBase.prototype;

    // #endregion


    // #region StudentDetailDay - Methods
    ns.StudentDetailDay.prototype.createReservation = function (activityScheduleID) {
        return {
            activityReservationID: 0,
            activityID: this.activityID,
            studentID: this.resourceID,
            activityScheduleID: activityScheduleID,
            firstPeriodStartDate: null,
            firstPeriodEndDate: null,
            secondPeriodStartDate: null,
            secondPeriodEndDate: null,
            lunch: false,
            fistSnack: false,
            secondSnack: false,
            notes: null
        };
    }

    ns.StudentDetailDay.prototype.applyChanges = function () {

        var hasFirstPeriod = (!!this.firstPeriodStartDate && !!this.firstPeriodEndDate);
        var hasSecondPeriod = (!!this.secondPeriodStartDate && !!this.secondPeriodEndDate);

        this.parent.applyChanges.call(this);

        if (!(hasFirstPeriod || hasSecondPeriod)) {
            this.lunchChanged = false;
            this.firstSnackChanged = false;
            this.secondSnackChanged = false;
        } else {
            if (this.lunchChanged) {
                this.applyChangesToBoolProperty(this.daySchedules, this.reservations, 'lunch', this.lunch);
                this.lunchChanged = false;
            }
            if (this.firstSnackChanged) {
                this.applyChangesToBoolProperty(this.daySchedules, this.reservations, 'firstSnack', this.firstSnack);
                this.firstSnackChanged = false;
            }
            if (this.secondSnackChanged) {
                this.applyChangesToBoolProperty(this.daySchedules, this.reservations, 'secondSnack', this.secondSnack);
                this.secondSnackChanged = false;
            }
        }
    }

    ns.StudentDetailDay.prototype.calculateProperties = function (schedules, reservations, dayOfWeek) {

        this.parent.calculateProperties.call(this, schedules, reservations, dayOfWeek);

        this._lunch = this.getBoolValue(this.daySchedules, this.dayReservations, 'lunch');
        this._firstSnack = this.getBoolValue(this.daySchedules, this.dayReservations, 'firstSnack');
        this._secondSnack = this.getBoolValue(this.daySchedules, this.dayReservations, 'secondSnack');

        this.lunchIndeterminate = this.isBoolIndeterminate(this.daySchedules, this.dayReservations, 'lunch');
        this.firstSnackIndeterminate = this.isBoolIndeterminate(this.daySchedules, this.dayReservations, 'firstSnack');
        this.secondSnackIndeterminate = this.isBoolIndeterminate(this.daySchedules, this.dayReservations, 'secondSnack');

        this.lunchNotScheduled = this.notScheduledProperty(this.daySchedules, 'lunch');
        this.firstSnackNotScheduled = this.notScheduledProperty(this.daySchedules, 'firstSnack');
        this.secondSnackNotScheduled = this.notScheduledProperty(this.daySchedules, 'secondSnack');
    }

    // #endregion

    // #region StudentDetailDay - Properties

    Object.defineProperty(ns.StudentDetailDay.prototype, "active", {
        get: function () { return this.parent.getActive.call(this); },
        set: function (value) {
            this.parent.setActive.call(this, value);
            if (value) {
                if (!this.lunchNotScheduled) {
                    this.lunch = true;
                }
                if (!this.firstSnackNotScheduled) {
                    this.firstSnack = true;
                }
                if (!this.secondSnackNotScheduled) {
                    this.secondSnack = true;
                }
            } else {
                this.lunch = false;
                this.firstSnack = false;
                this.secondSnack = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.StudentDetailDay.prototype, "amActive", {
        get: function () { return this.parent.getAmActive.call(this); },

        set: function (value) {
            this.parent.setAmActive.call(this, value);
            if (value) {
                if (!this.lunchNotScheduled) {
                    this.lunch = true;
                }
                if (!this.firstSnackNotScheduled) {
                    this.firstSnack = true;
                }
            } else {
                this.lunch = false;
                this.firstSnack = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.StudentDetailDay.prototype, "pmActive", {
        get: function () { return this.parent.getPmActive.call(this); },

        set: function (value) {
            this.parent.setPmActive.call(this, value);
            if (value) {
                if (!this.secondSnackNotScheduled) {
                    this.secondSnack = true;
                }
            } else {
                this.secondSnack = false;
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.StudentDetailDay.prototype, "lunch", {
        get: function () {
            return this._lunch;
        },
        set: function (value) {
            this._lunch = value;
            this.lunchChanged = true;
            if (value !== undefined) {
                this.lunchIndeterminate = this.isBoolIndeterminate2(this.daySchedules, 'lunch', value, false);
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.StudentDetailDay.prototype, "firstSnack", {
        get: function () {
            return this._firstSnack;
        },
        set: function (value) {
            this._firstSnack = value;
            this.firstSnackChanged = true;
            if (value !== undefined) {
                this.firstSnackIndeterminate = this.isBoolIndeterminate2(this.daySchedules, 'firstSnack', value, false);
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.StudentDetailDay.prototype, "secondSnack", {
        get: function () {
            return this._secondSnack;
        },
        set: function (value) {
            this._secondSnack = value;
            this.secondSnackChanged = true;
            if (value !== undefined) {
                this.secondSnackIndeterminate = this.isBoolIndeterminate2(this.daySchedules, 'secondSnack', value, false);
            }
        },
        enumerable: true,
        configurable: true
    });

    // #endregion



}(webooker_acivity_models));
